module.exports = __webpack_public_path__ + "media/images/parcel-391be8e5baa0d86d730fa1726013d507.svg";